import { IMenuItem } from 'models/IMenuItem';
import { NotifyLink } from 'components/Shared/NotifyLink';
import styles from './styles.scss';
import { useState } from 'react';
import cn from 'classnames';
import { hasElements } from 'utils';
import { getQaDataAttr } from '@bygghemmait/utilities';
import { useTouchStartNavigate } from 'components/MainMenu/useTouchStartNavigate';

export interface OwnProps extends IMenuItem {
  openMenu: () => void;
  closeMenu: () => void;
  isOpen: boolean;
  isLoading: boolean;
}

interface SubCategoryProps {
  subCategories: IMenuItem[];
}

const SubCategories = ({ subCategories }: SubCategoryProps) => (
  <ul className={cn(styles.subCategories)}>
    {subCategories.map(category => (
      <li className={cn(styles.subCategoryItem)} key={category.title}>
        <NotifyLink
          className={styles.subCategoryLink}
          ticket={category.ticket}
          url={category.url}
          {...getQaDataAttr(`link-nav-${category.id}`)}
        >
          {category.title}
        </NotifyLink>
      </li>
    ))}
  </ul>
);

export const Section = ({
  title,
  openMenu,
  closeMenu,
  isOpen,
  isLoading,
  subCategories,
  id,
  ...props
}: OwnProps) => {
  const [, setRef] = useTouchStartNavigate<HTMLAnchorElement | undefined>(useState(), {
    isLoading,
    isOpen,
    openMenu,
    closeMenu
  });

  const hasSubcategories = hasElements(subCategories);
  const showSubcategories = isOpen && hasSubcategories;

  return (
    <>
      <div onMouseOver={openMenu} onMouseOut={closeMenu} className={styles.section}>
        <NotifyLink
          className={cn(styles.sectionLink, { [styles.open]: showSubcategories })}
          ticket={props.ticket}
          url={props.url}
          setRef={setRef}
          {...getQaDataAttr(`link-nav-${id}`)}
        >
          <span className={styles.sectionTitle}>{title}</span>
        </NotifyLink>
      </div>
      {showSubcategories && (
        <div onMouseOver={openMenu} onMouseOut={closeMenu} className={styles.subCategoryWrapper}>
          <SubCategories subCategories={subCategories} />
          <div className={styles.subCategoryBackground} />
        </div>
      )}
    </>
  );
};
